import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { handleSubscriptionSuccess } from '../../api/subscription';
import { toast } from 'react-toastify';

const SubscriptionSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const processSubscription = async () => {
      const sessionId = searchParams.get('session_id');
      
      if (!sessionId) {
        toast.error('Invalid session');
        navigate('/dashboard');
        return;
      }

      try {
        const response = await handleSubscriptionSuccess({ session_id: sessionId });
        
        if (response?.code === 1) {
          toast.success('Subscription activated successfully! Welcome aboard!');
          setTimeout(() => {
            navigate('/dashboard');
          }, 5000);
        } else {
          toast.error(response?.message || 'Failed to process subscription');
          navigate('/dashboard');
        }
      } catch (error) {
        console.error('Error processing subscription:', error);
        toast.error('An error occurred while processing your subscription');
        navigate('/dashboard');
      } finally {
        setProcessing(false);
      }
    };

    processSubscription();
  }, [searchParams, navigate]);

  return (
    <div className="container-fluid">
      <div className="row justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="col-md-6 text-center">
          <div className="card shadow-lg border-0" style={{ borderRadius: '15px' }}>
            <div className="card-body p-5">
              {processing ? (
                <>
                  <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
                  <h3 className="mt-4 mb-3">Processing Your Subscription...</h3>
                  <p className="text-muted">Please wait while we activate your subscription.</p>
                </>
              ) : (
                <>
                  <div className="mb-4">
                    <i className="fa fa-check-circle text-success" style={{ fontSize: '80px' }}></i>
                  </div>
                  <h2 className="mb-3">Payment Successful!</h2>
                  <p className="text-muted">Your subscription has been activated.</p>
                  <p className="text-muted">Redirecting to dashboard...</p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
